import { createSlice } from '@reduxjs/toolkit';

import { fetchInvitedPosts } from './invitedPostsThunks';
import { invitedSubCategories } from './../../pages/InvitedPosts/InvitedPosts';
import _cloneDeep from 'lodash/cloneDeep';

export const initialState = {
    inProgress: [],
    invitedOpportunities: [],
    publicOpportunities: [],
    category: null,
    loading: false,
    error: false,
};

const InvitedPostsSlice = createSlice({
    name: 'invitedPosts',
    initialState,
    reducers: {
        removePostFromInvitesList: (state, { payload }) => {
            switch (payload.subCategoryTitle) {
                case invitedSubCategories.inProgress:
                    state.inProgress = state.inProgress.filter(post => post.uid !== payload.id);
                    break;
                case invitedSubCategories.invitedOpportunities:
                    state.invitedOpportunities = state.invitedOpportunities.filter(
                        post => post.uid !== payload.id
                    );
                    break;
                case invitedSubCategories.publicOpportunities:
                    state.publicOpportunities = state.publicOpportunities.filter(
                        post => post.uid !== payload.id
                    );
                    break;
                default:
                    break;
            }
        },
        changePostAfterAnswer: (state, { payload }) => {
            let index;
            switch (payload.subCategoryTitle) {
                case invitedSubCategories.invitedOpportunities:
                    index = state.invitedOpportunities.findIndex(
                        post => post.uid === payload.rawPostData.uid
                    );
                    state.invitedOpportunities[index] = _cloneDeep(payload.rawPostData);
                    break;
                case invitedSubCategories.publicOpportunities:
                    index = state.publicOpportunities.findIndex(
                        post => post.uid === payload.rawPostData.uid
                    );
                    state.publicOpportunities[index] = _cloneDeep(payload.rawPostData);
                    break;
                default:
                    break;
            }
        },
    },
    extraReducers: builder => {
        builder.addCase(fetchInvitedPosts.pending, state => {
            state.error = false;
            state.loading = true;
        });
        builder.addCase(fetchInvitedPosts.fulfilled, (state, { payload }) => {
            state.inProgress = payload.inProgress;
            state.invitedOpportunities = payload.invitedOpportunities;
            state.publicOpportunities = payload.publicOpportunities;
            state.loading = false;
        });
        builder.addCase(fetchInvitedPosts.rejected, (state, { payload }) => {
            state.error = true;
            state.loading = false;
            alert(payload);
        });
    },
});

export const InvitedPostsReducer = InvitedPostsSlice.reducer;
export const InvitedPostsActions = {
    ...InvitedPostsSlice.actions,
    fetchInvitedPosts,
};
